import { IS_DEV } from "@/__main__/constants.mjs";

export class NotFoundError extends Error {
  statusCode: number;
  constructor(message?: string) {
    super(message);
    this.name = "NotFoundError";
    this.statusCode = 404;
  }
}

export class RedirectError extends Error {
  statusCode: number;
  redirect: string | boolean | undefined;
  constructor(redirectPath?: string | boolean) {
    super(`Redirect! ${redirectPath}`);
    this.name = "Redirect";
    this.statusCode = IS_DEV ? 303 : 301;
    this.redirect = redirectPath;
  }
}

export class ValidationFailedError extends Error {
  constructor(
    message: string,
    public writeStatePath: readonly PropertyKey[],
  ) {
    super(
      `${message} writeStatePath: ${
        writeStatePath?.join(".") ?? writeStatePath
      }`,
    );
    this.name = "ValidationFailedError";
    this.writeStatePath = writeStatePath;
  }
}

export class NetworkError extends Error {
  text?: string;

  constructor(message?: string) {
    super(message);
    this.name = "NetworkError";
  }
}

export class ModuleImportError extends NetworkError {
  constructor(message?: string) {
    super(message);

    this.name = "ModuleImportError";
  }
}

export class GraphQLError extends NetworkError {
  url: string;
  errorMessage: string;

  statusCode?: number;
  errorCode?: string;

  constructor(
    message: string,
    {
      url,
      errorMessage,
      statusCode,
      errorCode,
    }: {
      url: string;
      errorMessage: string;

      statusCode?: number;
      errorCode?: string;
    },
  ) {
    super(message);

    this.name = "GraphQLError";

    this.url = url;
    this.errorMessage = errorMessage;

    this.statusCode = statusCode;
    this.errorCode = errorCode;
  }
}

export class PrivacyError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "PrivacyError";
  }
}
